import React from 'react'
import PropTypes from 'prop-types'

import Form from 'component/utils/Form'
import Modal from 'component/utils/Modal'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'

import CheckboxAltChecked from 'images/checkbox-alt-checked.svg'
import CheckboxAltUnchecked from 'images/checkbox-alt-unchecked.svg'

const FIELDS = ['idSourceDepositList', 'idDestinationDepositList']

const MissionBlockRemoveModal = ({
  cdMissionListLength,
  closeModal,
  depositList,
  fields,
  setValueToField,
  submit,
  translate,
  values,
  values: { idSourceDepositList, idDestinationDepositList },
}) => {
  const renderOptions = (idDepositList, field, id) => {
    const renderOption = (deposit) => {
      const { idDeposit } = deposit

      const currentValue = values[field]

      const checked = idDepositList.some((depositId) => depositId === idDeposit)

      return (
        <label
          key={idDeposit}
          onClick={() =>
            setValueToField(
              fields[field].input.name,
              checked
                ? currentValue.filter((i) => i !== idDeposit)
                : [...currentValue, idDeposit]
            )
          }
          style={{ display: 'block', margin: '.5rem auto' }}
        >
          <img
            src={checked ? CheckboxAltChecked : CheckboxAltUnchecked}
            className='margin-right'
            style={{ float: 'left', margin: 'auto .5rem' }}
          />
          {`${deposit.idDeposit} - ${deposit.dsDeposit}`}
        </label>
      )
    }

    return (
      <>
        <strong style={{ display: 'block', margin: '1rem auto' }}>
          {translate(`stockTransfer.missionBlock.${id}`)}
        </strong>
        {depositList.map(renderOption)}
      </>
    )
  }

  const isDisabled = () =>
    !idSourceDepositList.length && !idDestinationDepositList.length

  const beforeSubmit = () => {
    const param = { ...values, removeAll: true }

    submit(param)
  }

  return (
    <Modal
      closeModal={closeModal}
      size='md'
      className='mission-block-edit-modal'
    >
      <h3>
        <strong>
          {translate('stockTransfer.missionBlock.modal.remove.title')}
        </strong>
      </h3>
      <p>
        <strong>{`${cdMissionListLength} ${translate(
          `stockTransfer.missionBlock.selection.quantity${
            cdMissionListLength > 1 ? 'Plural' : 'Singular'
          }`
        )}`}</strong>
      </p>
      <p>
        <strong>
          {translate('stockTransfer.missionBlock.modal.remove.text')}
        </strong>
      </p>
      <section style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
        <div>
          {renderOptions(idSourceDepositList, 'idSourceDepositList', 'source')}
        </div>
        <div>
          {renderOptions(
            idDestinationDepositList,
            'idDestinationDepositList',
            'destination'
          )}
        </div>
      </section>
      <Row className='margin-top-quadruple'>
        <Col xs={4} xsOffset={4}>
          <button
            disabled={isDisabled()}
            onClick={beforeSubmit}
            className='button button-primary button-full'
          >
            {translate('save_button_label')}
          </button>
        </Col>
      </Row>
    </Modal>
  )
}

MissionBlockRemoveModal.propTypes = {
  cdMissionListLength: PropTypes.number.isRequired,
  closeModal: PropTypes.func.isRequired,
  depositList: PropTypes.array.isRequired,
  fields: PropTypes.object.isRequired,
  setValueToField: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
}

export default Form({ fields: FIELDS })(MissionBlockRemoveModal)

export { MissionBlockRemoveModal }
